export interface BookshelfGroupDefinition {
  id: string;
  label: string;
}

// 默认分组用于书架过滤和详情分组选择
export const bookshelfGroups: BookshelfGroupDefinition[] = [
  { id: "main", label: "我的书架" },
  { id: "updates", label: "追更" },
];

export const defaultBookshelfGroupId = bookshelfGroups[0]!.id;
